<template>
  <div>
    <secondHeader />
    <div class="main">
      <sidebar />
      <div class="content">
        <noticeBar />
        <div class="bl_media_container">
          <div class="message">
            <h2>ライブ配信者のためのツール集</h2>
          </div>
          <div
            class="bl_media_itemWrapper"
            v-for="toolKit in toolKits"
            :key="toolKit.index"
          >
            <router-link v-if="toolKit.type === 'internal'" :to="toolKit.to">
              <div class="bl_media_item">
                <img class="card-img" :src="toolKit.src" alt="" />
                <div class="media-content">
                  <h3>{{ toolKit.title }}</h3>
                  <p>{{ toolKit.description }}</p>
                </div>
              </div>
            </router-link>
            <a v-if="toolKit.type === 'external'" :href="toolKit.to" target="_blank" rel="noopener noreferrer">
              <div class="bl_media_item">
                <img class="card-img" :src="toolKit.src" alt="" />
                <div class="media-content">
                  <h3>{{ toolKit.title }}</h3>
                  <p>{{ toolKit.description }}</p>
                </div>
              </div>
            </a>
          </div>
          <div class="flex">
            <div
              class="bl_media_itemWrapper ruri-bannar"
            >
              <a href="https://talk-boost.com/" target="_blank" rel="noopener noreferrer">
                <img src="@/assets/talkboost-banner.png" alt="" class="service-banner" />
              </a>
            </div>
            <div
              class="bl_media_itemWrapper ruri-bannar"
            >
              <a href="https://hari-stream.com/" target="_blank" rel="noopener noreferrer">
                <img src="@/assets/hari-banner.png" alt="" class="service-banner" />
              </a>
            </div>
          </div>
          <div class="ad">
            <InFeedAdsense
                data-ad-layout-key="-fb+5w+4e-db+86"
                data-ad-client="ca-pub-9016794589237931"
                data-ad-slot="4898735474">
            </InFeedAdsense>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import secondHeader from "../components/secondHeader.vue";
import sidebar from "../components/sidebar.vue"
import noticeBar from "../components/notice-bar.vue"

export default {
  components: {
    secondHeader,
    sidebar,
    noticeBar,
  },
  data() {
    return {
      isProduction: process.env.NODE_ENV === "production",
      toolKits: [
        {
          index: 1,
          type: "internal",
          src: require("@/assets/carousel/gradation_clock.png"),
          to: "/clockcreate",
          title: "配信用デジタル時計",
          description:
            "カスタマイズ可能な時計を複数用意。自由なコンセプトを実現できます。",
        },
        {
          index: 2,
          type: "internal",
          src: require("@/assets/carousel/fukidashi.png"),
          to: "/ytcomment",
          title: "YouTube・Twitchコメント欄",
          description:
            "YouTubeLIVE・Twitchのコメント欄を簡単にカスタマイズ。複数のデザインから選べます。",
        },
        {
          index: 3,
          type: "internal",
          src: require("@/assets/thumbnail/discordroom.png"),
          to: "/discordroom",
          title: "DiscordオーバレイCSS",
          description:
            "Discordのオーバレイをカスタマイズ。オリジナルのアニメーションを用意しています。",
        },
        {
          index: 4,
          type: "internal",
          src: require("@/assets/thumbnail/timer-preview.png"),
          to: "/timer",
          title: "タイマー",
          description:
            "配信画面に載せれるシンプルタイマー。同時視聴をするときに便利です。",
        },
        {
          index: 5,
          type: "internal",
          src: require("@/assets/thumbnail/counter.png"),
          to: "/counter",
          title: "デザインカウンター",
          description: "デザイン性の高いカウンターをOBSに簡単導入。",
        },
        {
          index: 6,
          type: "internal",
          src: require("@/assets/thumbnail/textcount.png"),
          to: "/textcount",
          title: "文字カウンター",
          description: "シンプルな文字カウンター。ただ文字数を測れます。",
        },
        {
          index: 7,
          type: "internal",
          src: require("@/assets/thumbnail/roulette.png"),
          to: "/roulette",
          title: "ルーレット",
          description: "軽量なルーレットアプリです。",
        },
        {
          index: 8,
          type: "external",
          src: require("@/assets/thumbnail/setolisan-thomnail.png"),
          to: "https://takatsukisyou.booth.pm/items/5826705",
          title: "SETOLI-SAN",
          description: "OBS内だけで使えるセトリ管理ツール「セトリサン」",
        },
      ],
    };
  },
};
</script>
<style scoped>
.main {
  min-height: 100vh;
  display: flex;
  flex-direction: row;
  flex-grow: 1;
  margin: 0 auto;
  background: linear-gradient(-225deg, #acb6e5 0%, #fff 25%,#fff 75%, #FFBAC3 100%);
}

.content {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  padding: 60px 0 60px 1.82%;
}

.message{
  display: block;
  width: 100%;
}

h2{
  margin: calc(30px / 2);
  letter-spacing: 3px;
  text-shadow: 2px 2px 6px rgb(210 210 210 / 80%);
}

h3 {
  letter-spacing: 3px;
  text-shadow: 2px 2px 6px rgb(210 210 210 / 80%);
}

img {
  width: 100%;
  vertical-align: bottom;
}
.card-img {
  object-fit: contain;
  height: auto;
  width: 30%;
  /* overflow: hidden;
  border-radius: 8px;
  box-shadow: 0 4px 15px rgba(0,0,0,.2); */
}

/* .card-img img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
} */
.bl_media_container {
  display: flex;
  flex-wrap: wrap;
  margin: 0 auto;
  max-width: 1080px;
  padding: 30px;
}
.bl_media_itemWrapper {
  width: calc(100% / 2 - 30px);
  margin: calc(30px / 2);
}
.bl_media_item {
  display: flex;
  background: #ffffff;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 2px 4px rgb(0 0 0 / 5%);
  color: #000000;
  text-decoration: none;
  transition: all .5s;
}

.bl_media_item:hover {
  transform: translateY(-5px);
  box-shadow: 0 7px 34px rgba(50,50,93,.1), 0 3px 6px rgb(0 0 0 / 5%);
}

.media-content{
  padding-left: 12px;
}

.bl_media_itemWrapper a {
  text-decoration: none;
}
.bl_media_item p {
  font-size: 14px;
}

@media screen and (min-width: 600px) {
  .bl_media_itemWrapper {
    width: calc(100% / 2 - 30px);
  }

  .flex {
    display: flex;
}

}

@media screen and (max-width: 599px) {
  .bl_media_itemWrapper {
    width: calc(100% / 1 - 30px);
  }

  .flex {
    display: block;
  }
}


.ruri-bannar{
  transition: all .5s;
}

.ruri-bannar:hover{
  transform: translateY(-5px);
  box-shadow: 0 7px 34px rgba(50,50,93,.1), 0 3px 6px rgb(0 0 0 / 5%);
}

.banner {
  max-height: 500px;
  width: 80%;
  margin: 0 auto;
  margin-top:24px;
  padding-bottom: 24px;
  text-align: center;
  box-sizing: border-box;
}
.banner img {
  height: 100%;
  max-width: 756px;
  object-fit: cover;
}

.ad-block{
  padding: 12px 0px;
  display: block;
  width: 100%;
}
.ad {
  max-height: 300px;
  max-width: 70%;
  margin: 0 auto;
  padding-bottom: 24px;
  text-align: center;
  box-sizing: border-box;
}

.service-banner{
  border-radius: 0.375rem;
  transition-duration: .3s;
}

</style>